<div *ngIf="status" class="loader-wrapper" [style.height]="height">
    <div class="loader-body">
        <div class="loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>